import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Section, SEO } from "src/components/common"
import { Prose } from "./styles"

export const Content = ({ content, seoKey, descriptionKey }) => {
  const { t } = useTranslation()
  return (
    <>
      <SEO
        title={t(`seo:${seoKey}`)}
        description={descriptionKey ? t(`seo:${descriptionKey}`) : undefined}
      />
      <Section as="article" aria-labelledby="content-title">
        <Container $narrow>
          <h1
            id="content-title"
            dangerouslySetInnerHTML={{ __html: t(`${content}:title`) }}
          />
          <Prose dangerouslySetInnerHTML={{ __html: t(`${content}:text`) }} />
        </Container>
      </Section>
    </>
  )
}
